import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
// import {FormFeedback as FormFeedbackBootstrap} from 'reactstrap';
import propTypes from 'prop-types';
import classNames from 'classnames';

export default class FormFeedback extends Component{
    getError(){
        return this.props.errors && Object.keys(this.props.errors)
        .filter(err => err===this.props.field)
        .length>0
    }
    render(){
        if(this.getError() || this.props.valid)
            return <div className={classNames({'valid-feedback':this.props.valid,'invalid-feedback':!this.props.valid})}>{this.props.valid? this.props.children : this.props.errors[this.props.field][0]}</div>
        return null
    }
}

FormFeedback.propTypes={
    valid: propTypes.bool,
    children: propTypes.node,
    errors:propTypes.object,
    field:propTypes.string.isRequired
}

FormFeedback.defaultProps={
    errors:{},
    valid: false
}